<template>
    <div class="header bg">
        <div class="header-container">
            <div class="header-content">
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.header {
    &-container {
        background: rgba(49, 150, 250, 0.1);
    }
    &-content {
        padding: 0 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        font-size: 28px;
        color: #999999;
    }
}
</style>
